import { ArrowDownTrayIcon, TrashIcon } from '@heroicons/react/24/outline';
import CT from '@marketplace-ai/tags';
import { useSelector } from '@xstate/react';
import { useState } from 'react';
import { FormDialog, TableCard } from '~/components';
import { usePrivilegesRef } from '../account/vaultSelectors';
import { AddPrivilegesGrid } from './AddPrivilegesGrid';
import { PrivilegesForm } from './PrivilegesForm';
import { PrivilegesGrid } from './PrivilegesGrid';

const tableActionBtnClass =
  'flex items-center gap-2 rounded-lg px-3.5 py-2 body-text-sb text-primary-50 border border-primary-t-700 hover:bg-primary-t-900 hover:border-primary-t-600 transition-colors';
const TAGS = CT.privileges.table;

export const PrivilegesDetails = () => {
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const { privilegesRef } = usePrivilegesRef();
  if (!privilegesRef) {
    return null;
  }
  const privilegeCrudMachine = useSelector(privilegesRef, (state) => state.context.crudRef);
  const { creatingCustom } = useSelector(privilegesRef, (state) => state.context);
  const { create, edit } = useSelector(privilegeCrudMachine, (state) => state.context.modal);

  const handleOpen = () => {
    privilegeCrudMachine.send({ type: 'ON_ADD' });
    privilegesRef.send({ type: 'ON_GET_AVAILABLE_PRIVILEGES' });
  };

  const handleCsvExport = () => {
    privilegesRef.send({ type: 'ON_DOWNLOAD' });
  };

  const handleMultipleDelete = () => {
    privilegesRef.send({ type: 'ON_DELETE_MULTIPLE', payload: { ids: selectedIds } });
  };

  const handleClose = () => {
    privilegeCrudMachine.send({ type: 'ON_CLOSE_MODAL' });
    privilegesRef.send({ type: 'ON_CLOSE_MODAL' });
  };

  return (
    <>
      <TableCard
        mobilePageHeader
        title="Privileges"
        addLabel="Add Privileges"
        onAddClick={handleOpen}
        addBtnTag={TAGS.addBtn}
        layoutTag={CT.privileges.layout}
        customButtons={[
          <button
            type="button"
            data-cy={TAGS.deleteMultipleBtn}
            className={tableActionBtnClass}
            onClick={handleMultipleDelete}
          >
            <TrashIcon className="size-5" aria-hidden="true" />
            Delete Selected
          </button>,
          <button
            type="button"
            data-cy={TAGS.exportCsvBtn}
            className={tableActionBtnClass}
            onClick={handleCsvExport}
          >
            <ArrowDownTrayIcon className="size-5" aria-hidden="true" />
            Export to CSV
          </button>,
        ]}
      >
        <div style={{ height: '520px' }}>
          <PrivilegesGrid setSelectedIds={setSelectedIds} />
        </div>
      </TableCard>
      <FormDialog
        title={creatingCustom ? 'Add Custom Privilege' : 'Edit Privilege'}
        editing={edit}
        creating={creatingCustom}
        onClose={handleClose}
        padding={'pt-4'}
        bgColor={'white'}
        width={'4xl'}
      >
        <PrivilegesForm handleClose={handleClose} actor={privilegesRef} />
      </FormDialog>
      <FormDialog
        editing={false}
        creating={create}
        onClose={handleClose}
        padding={'pt-0'}
        bgColor={'base'}
        width={'5xl'}
      >
        <AddPrivilegesGrid />
      </FormDialog>
    </>
  );
};
